import type { PageContext } from 'vike/types';
import type { Data } from './+data';
import { buildClampedTitle } from '../../../../utils/seo/clamp-meta-title';

// Utility to transform FinalJob to DisplayJob for a given locale
function transformJobForLanguage(job: any, lang: string): any {
  const jobObj = job as Record<string, unknown>;
  const result: Record<string, unknown> = {};
  const langSuffix = `_${lang}`;
  for (const key in jobObj) {
    if (key.endsWith(langSuffix)) {
      const baseKey = key.slice(0, -langSuffix.length);
      result[baseKey] = jobObj[key];
    } else if (!key.match(/_en$|_sv$|_fi$/)) {
      result[key] = jobObj[key];
    }
  }
  if (result.objectID) {
    result.objectID = `${result.objectID}`;
  }
  return result;
}

export default (pageContext: { data?: { job?: unknown; metaTitle?: string }; routeParams?: unknown }) => {
  const data = pageContext?.data || {};
  const job = data.job || {};
  const metaTitle = data.metaTitle;
  const company = job.companyId || '';
  
  if (metaTitle && String(metaTitle).trim()) {
    // Full string in <title>; no manual ellipsis — crawlers clip in SERPs when needed
    return String(metaTitle).trim();
  }
  
  return buildClampedTitle(['Job', company, 'JobCrawls'], ' | ');
}; 